import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogIn } from 'react-feather';
import man from '../../../assets/images/dashboard/profile.png';
import { logoutUser } from '../../../Services/authService';

import { LI, UL, P } from '../../../AbstractElements';

const UserHeader = () => {
  const navigate = useNavigate();
  const [, setProfile] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [profileDropDown, setProfileDropDown] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [isOtherLocked, setIsOtherLocked] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const updateUserData = () => {
      setProfile(localStorage.getItem('profileURL') || man);
      const storedName = localStorage.getItem('userFullName');
      setName(storedName || 'Kullanıcı');
      const storedRole = localStorage.getItem('userRole');
      setRole(storedRole || 'Kullanıcı');
    };

    // Initial load
    updateUserData();

    // Listen for role changes
    const handleRoleChange = () => {
      updateUserData();
    };

    window.addEventListener('userRoleChanged', handleRoleChange);

    return () => {
      window.removeEventListener('userRoleChanged', handleRoleChange);
    };
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!dropdownRef.current) return;
      if (!dropdownRef.current.contains(event.target)) {
        setProfileDropDown(false);
        setIsLocked(false);
        setIsOtherLocked(false);
        window.dispatchEvent(
          new CustomEvent('headerDropdownState', { detail: { source: 'profile', locked: false } })
        );
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const handleDropdownState = (event) => {
      const { source, locked } = event.detail || {};
      if (source === 'profile') return;

      if (locked) {
        setIsOtherLocked(true);
        setProfileDropDown(false);
        setIsLocked(false);
      } else {
        setIsOtherLocked(false);
        if (!isLocked) {
          setProfileDropDown(false);
        }
      }
    };

    window.addEventListener('headerDropdownState', handleDropdownState);

    return () => {
      window.removeEventListener('headerDropdownState', handleDropdownState);
    };
  }, [isLocked]);

  const handleDropdownToggle = () => {
    setIsLocked((prevLocked) => {
      const nextLocked = !prevLocked;
      if (nextLocked) {
        setProfileDropDown(true);
        window.dispatchEvent(
          new CustomEvent('headerDropdownState', { detail: { source: 'profile', locked: true } })
        );
      } else {
        setProfileDropDown(false);
        window.dispatchEvent(
          new CustomEvent('headerDropdownState', { detail: { source: 'profile', locked: false } })
        );
      }
      return nextLocked;
    });
  };

  const handleDropdownOpen = () => {
    if (isLocked || isOtherLocked) return;
    setProfileDropDown(true);
    window.dispatchEvent(
      new CustomEvent('headerDropdownState', { detail: { source: 'profile', locked: false } })
    );
  };

  const handleDropdownClose = () => {
    if (isLocked) return;
    setProfileDropDown(false);
    window.dispatchEvent(
      new CustomEvent('headerDropdownState', { detail: { source: 'profile', locked: false } })
    );
  };

  const Logout = () => {
    logoutUser();
    setProfileDropDown(false);
    setIsLocked(false);
    setIsOtherLocked(false);
    window.dispatchEvent(
      new CustomEvent('headerDropdownState', { detail: { source: 'profile', locked: false } })
    );
    navigate(`${process.env.PUBLIC_URL || ''}/login`);
  };

  return (
    <li
      className='profile-nav onhover-dropdown pe-0 py-0'
      onMouseEnter={handleDropdownOpen}
      onMouseLeave={handleDropdownClose}
      ref={dropdownRef}
    >
      <div className='media profile-media' onClick={handleDropdownToggle}>
        <div className='media-body'>
          <span>{name}</span>
          <P attrPara={{ className: 'mb-0 font-roboto' }}>
            {role}
            <i className='middle fa fa-angle-down'></i>
          </P>
        </div>
      </div>
      <UL
        attrUL={{
          className: `simple-list profile-dropdown onhover-show-div ${
            profileDropDown ? 'active' : ''
          }`,
        }}
      >
        {/*
        <LI attrLI={{ onClick: handleAccountNavigation }}>
          <User />
          <span>Hesabım</span>
        </LI>
        */}
        <LI attrLI={{ onClick: Logout }}>
          <LogIn />
          <span>Çıkış</span>
        </LI>
      </UL>
    </li>
  );
};

export default UserHeader;
